<template>
  <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(date) }}</small>
</template>

<script>
export default {
  props: ["date"],
  methods: {
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " jaren " : " jaar ") + "geleden";
      } else if (days > 0) {
        return days + (days > 1 ? " dagen " : " dag ") + "geleden";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " uur " : " uur ") + "geleden";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Minuten " : " Minuut ") + "geleden";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? " seconden geleden" : "Nu");
      }

      return "Nu";
    }
  }
};
</script>

<style scoped>
small {
  float: right;
}
</style>
